import { render } from "./PatientDatatableRecordActions.vue?vue&type=template&id=7228fb91"
import script from "./PatientDatatableRecordActions.vue?vue&type=script&lang=js"
export * from "./PatientDatatableRecordActions.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__